import { Grid, Typography } from '@mui/material';
import { LIGHT_GREY } from 'utilities/colors';
import Checkbox from '@mui/material/Checkbox';

export const ActiveOrderNotes = ({
  slide,
  setIsActiveOrderNotes,
  isActiveOrderNotesChecked,
  setIsActiveOrderNotesChecked,
  classes,
}) => {
  const projectNotes = slide.order?.project?.active_order_notes || '';
  const teamNotes = slide.order?.project?.team?.active_order_notes || '';
  const organizationNotes =
    slide.order?.project?.team?.organization?.active_order_notes || '';

  if (!projectNotes && !teamNotes && !organizationNotes) {
    return null;
  }

  setIsActiveOrderNotes(projectNotes || teamNotes || organizationNotes);

  return (
    <Grid p={2} bgcolor={LIGHT_GREY}>
      <Typography variant="subtitle1" color="inherit" fontSize={20}>
        <b>Active Order Notes:</b>
      </Typography>
      <Grid container mb={3}>
        {projectNotes && (
          <Grid item xs={12}>
            <Typography variant="body1" marginTop={2} fontSize={18}>
              <b>Project Notes:</b> {projectNotes}
            </Typography>
          </Grid>
        )}
        {teamNotes && (
          <Grid item xs={12}>
            <Typography variant="body1" marginTop={2} fontSize={18}>
              <b>Team Notes:</b> {teamNotes}
            </Typography>
          </Grid>
        )}
        {organizationNotes && (
          <Grid item xs={12}>
            <Typography variant="body1" marginTop={2} fontSize={18}>
              <b>Organization Notes:</b> {organizationNotes}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid container alignItems="center">
        <Grid item className={classes.activeOrderNotesCheckboxWrapper}>
          <Checkbox
            className={classes.activeOrderNotesCheckbox}
            color="success"
            checked={isActiveOrderNotesChecked}
            onChange={() =>
              setIsActiveOrderNotesChecked(!isActiveOrderNotesChecked)
            }
          />
          <Typography variant="body1" fontWeight="bold">
            I have read and understand the active order notes.
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
